import { parseJSON } from '@/components/helpers/utils'
import { SearchspringCollectionProvider } from 'libs/searchspring/fetchers/collection'
import { SearchspringRecommendProvider } from 'libs/searchspring/fetchers/recommend'
import { BeaconAnalyticsProvider } from 'libs/searchspring/hooks/useBeaconAnalytics'
import { useRecommendationCardSettings } from 'libs/searchspring/hooks/useRecommendationCardSettings'

// Parse options helper
const parseSettings = (options) => {
  const parsedSettings = parseJSON(options)

  if (parsedSettings?.groupCells !== undefined) {
    const value = parsedSettings.groupCells

    if (value === 'true') {
      parsedSettings.groupCells = true
    } else if (value === 'false') {
      parsedSettings.groupCells = false
    } else if (!isNaN(value) && typeof value === 'string') {
      parsedSettings.groupCells = Number(value)
    }
  }

  return parsedSettings
}

// Individual provider components
export const RecommendationWrapper = ({ children, profile, productId, limit }) => (
  <SearchspringRecommendProvider profile={profile} productId={productId} limit={limit}>
    <BeaconAnalyticsProvider profile={profile}>
      {children}
    </BeaconAnalyticsProvider>
  </SearchspringRecommendProvider>
)

export const CollectionWrapper = ({ children, handle, limit }) => (
  <SearchspringCollectionProvider handle={handle} resultsPerPage={limit}>
    {children}
  </SearchspringCollectionProvider>
)

// Main component that uses the appropriate provider
export const ProductRecommendation = ({
  providerType = 'recommend',
  profile,
  handle,
  productId,
  itemClass,
  carouselSettings = {},
  productCardSettings,
  limit,
  useCssGrid = false,
  wrapperClassName = '',
  component: Component
}) => {
  const parsedSettings = parseSettings(carouselSettings)
  const { cardSettings } = useRecommendationCardSettings(productCardSettings)

  const renderedComponent = (
    <Component
      className={itemClass}
      options={parsedSettings}
      productCardSettings={cardSettings}
      limit={limit}
      useCssGrid={useCssGrid}
      wrapperClassName={wrapperClassName}
    />
  )

  if (providerType === 'collection') {
    return (
      <CollectionWrapper handle={handle} limit={limit}>
        {renderedComponent}
      </CollectionWrapper>
    )
  }

  if (providerType === 'recommend') {
    return (
      <RecommendationWrapper
        profile={profile}
        productId={productId}
        limit={limit}
      >
        {renderedComponent}
      </RecommendationWrapper>
    )
  }

  console.error(`Unknown provider type: ${providerType}`)
  return <div>Invalid provider type: {providerType}</div>
}

// For backward compatibility, you can also export a HOC version
export function withRecommendationProvider(Component, providerType = 'recommend') {
  return function WrappedComponent(props) {
    return <ProductRecommendation {...props} providerType={providerType} component={Component} />
  }
}
